import { combineSlices } from '@reduxjs/toolkit'
import { authSlice } from '@/platform/auth/model/authSlice'
import { googleDriveSlice } from '@/platform/google-drive/model/googleDriveSlice'

export interface LazyLoadedSlices {}

export const rootReducer = combineSlices(authSlice, googleDriveSlice).withLazyLoadedSlices<LazyLoadedSlices>()
